export enum UnitMeasure {
  Kwh = 1,
  m3 = 2,
  dia = 3,
  bar = 7,
  KGM2 = 8,
  KwhDia = 10,
  ud = 12,
  mes = 14,
  KwhMes = 15,
  KwhTrimestre = 16,
  KwhAnio = 17,
  KwhDiaMes = 18,
  porcentaje = 21,
  KwhDiaDia = 24,
  Therm = 25,
  MWh = 26,
  kWhM3 = 27,
  kgM3 = 28,
  Kvarh = 29,
  W = 30,
  VA = 31,
  Wh = 32,
  VArh = 33,
  kW = 34,
  Euros = 36,
  GradosCentigrados = 37,
  GWh = 38,
  TWh = 39,
  Btu = 40,
  Bbtu = 41,
  Tbtu = 42,
  bbl = 43,
  MMBtu = 44,
  GJ = 45,
  MWhdia = 46,
  Wdia = 47,
  Wmes = 48,
  Wanio = 49,
  kWdia = 50,
  kWmes = 51,
  kWanio = 52,
  Kg = 53,
  KwhHora = 54,
  MwhHora = 55,
  MwhMes = 56,
  MwhTrimestre = 57,
  MwhAnio = 58,
  tn = 59,
  WhHora = 60,
  WhDia = 61,
  WhHMes = 62,
  WhTrimestre = 63,
  WhAnio = 64,
  MW = 65,
  ano = 66,
  KwhDiaAno = 67,
  MwhQHora = 68,
  kWhQHora = 69,
  WhQHora = 70,
  GJdia = 1011
}
